const Error = () => {
    return (<h2 className="error-msg">
        We could not download list of tasks.Try again later &#128532;
    </h2>)
}

export default Error